/* unplugin-vue-components disabled */import { render } from "./fujianshifanPop.vue?vue&type=template&id=3e5134dc&scoped=true"
import script from "./fujianshifanPop.vue?vue&type=script&lang=js"
export * from "./fujianshifanPop.vue?vue&type=script&lang=js"

import "./fujianshifanPop.vue?vue&type=style&index=0&id=3e5134dc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5134dc"]])

export default __exports__